import { common } from '@/api/index'

export function getSkinData () {
  return common.request({
    method: 'get',
    url: '/GetSkinData'
  })
}

export function getHideFeeTypeByGroupId (data) {
  return common.request({
    method: 'post',
    url: '/GetHideFeeTypeByGroupid',
    data
  })
}

export function Get_rowcolor (data) {
  return common.request({
    method: 'post',
    url: '/Get_rowcolor',
    data
  })
}

export function Add_rowcolor (data) {
  return common.request({
    method: 'post',
    url: '/Add_rowcolor',
    data
  })
}
export function getBSite (data) {
  return common.request({
    method: 'post',
    url: '/GetBSite',
    data
  })
}

